import React, { useState, useEffect } from 'react';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import CastingMenuPage from './pages/CastingMenuPage';
import CastingApplicationPage from './pages/CastingApplicationPage';
import DesignerApplicationPage from './pages/DesignerApplicationPage';
import LawApplicationPage from './pages/LawApplicationPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import './App.css';
// ++ Сесійний токен: автоматично додаємо Authorization до запитів на наш API
const AUTH_API_HOSTS = [
  'orkxz4jpah.execute-api.us-east-1.amazonaws.com',
  'j3g4jcz78i.execute-api.us-east-1.amazonaws.com',
  'amm8jymgmc.execute-api.us-east-1.amazonaws.com',
  'lc73ifzg1l.execute-api.us-east-1.amazonaws.com',
];
if (!window.__genesisFetchPatched) {
  window.__genesisFetchPatched = true;
  const origFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input.url;
      const host = new URL(url, window.location.href).host;
      if (AUTH_API_HOSTS.includes(host)) {
        const token = JSON.parse(localStorage.getItem('currentUser') || 'null')?.sessionToken;
        if (token) {
          const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
          if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
          init = { ...init, headers };
        }
      }
    } catch (e) { /* запит не ламаємо */ }
    return origFetch(input, init).then((res) => {
      try {
        const u = new URL(typeof input === 'string' ? input : input.url, window.location.href);
        if (res.status === 401 && AUTH_API_HOSTS.includes(u.host) && !u.pathname.endsWith('/login')) {
          res.clone().json().then((j) => {
            if (j && j.code === 'AUTH_REQUIRED') {
              localStorage.removeItem('currentUser');
              alert('Your session has expired. Please log in again.');
              window.location.href = '/login';
            }
          }).catch(() => {});
        }
      } catch (e) { /* не ламаємо відповідь */ }
      return res;
    });
  };
}
// ++ Старі входи без токена: один раз просимо увійти заново
try {
  const cu = JSON.parse(localStorage.getItem('currentUser') || 'null');
  if (cu && !cu.sessionToken) localStorage.removeItem('currentUser');
} catch (e) {}
function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // ✅ Перевірка URL при завантаженні
  useEffect(() => {
    const path = window.location.pathname;
    
    if (path === '/register') {
      setCurrentPage('register');
    } else if (path === '/login') {
      setCurrentPage('login');
    } else if (path === '/profile') {
      setCurrentPage('profile');
    } else if (path === '/casting-menu') {
      setCurrentPage('casting-menu');
} else if (path === '/casting-models') {
  setCurrentPage('casting-models');
} else if (path === '/casting-law') {
  setCurrentPage('casting-law');
} else if (path === '/casting-designers') {
  setCurrentPage('casting-designers');
} else if (path === '/reset-password') {
  setCurrentPage('reset-password');
} else {
  setCurrentPage('home');
}
  }, []);

  // ✅ Функція навігації зі зміною URL
  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.history.pushState({}, '', `/${page === 'home' ? '' : page}`);
  };

  const renderPage = () => {
    // Універсальні пропси
    const navProps = {
      setCurrentPage: handleNavigate,
      onNavigate: handleNavigate
    };

    switch(currentPage) {
      case 'home':
        return <HomePage {...navProps} />;
      case 'register':
        return <RegisterPage {...navProps} />;
      case 'login':
        return <LoginPage {...navProps} />;
      case 'profile':
        return <ProfilePage {...navProps} />;
      case 'casting-menu':
        return <CastingMenuPage {...navProps} />;
      case 'casting-models':
        return <CastingApplicationPage {...navProps} />;
      case 'casting-designers':
        return <DesignerApplicationPage {...navProps} />;
        case 'casting-law':
  return <LawApplicationPage {...navProps} />;
        case 'reset-password':
        return <ResetPasswordPage {...navProps} />;
      default:
        return <HomePage {...navProps} />;
    }
  };

  return <div className="App">{renderPage()}</div>;
}

export default App;
